import React, { useState, useEffect } from "react";
import { CheckCircle, Plus, Trash2 } from "lucide-react";
import CustomInput from "./common/CustomInput";
import CustomSelect from "./common/CustomSelect";
import AddBankAccountPopup from "./common/AddBankAccountPopup.jsx";
import BankStatementDashboard from "./BankStatementDashboard/BankStatementDashboard.jsx";
import Button from "./common/Button.jsx";
import CustomHeading from "./common/CustomHeading.jsx";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button as MuiButton,
} from "@mui/material";
import {
  getBankingData,
  // getBankReportData,
  getAllUploadedDocumentsListForProcessByUserId,
  saveBankStatementSection,
  saveFinancialSummaryApi,
  getBankStatementAnalysis,
  saveBankStatementAnalysis,
  // getCReditRelatedData,
  // getCRifRelatedData,
} from "../ActionCreator";

const formatMonth = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString("en-IN", {
    month: "short",
    year: "numeric",
  });
};

const formatTimelineDate = (dateStr) => {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).toUpperCase();
  } catch (e) {
    return dateStr;
  }
};

const getAvatarInfo = (email) => {
  const authorEmail = email || "superuser@wogom.com";
  const namePart = authorEmail.split("@")[0];
  const parts = namePart.split(".");
  
  let initials = "";
  if (parts.length >= 2) {
    initials = (parts[0][0] + parts[1][0]).toUpperCase();
  } else if (namePart.length >= 2) {
    initials = (namePart[0] + namePart[1]).toUpperCase();
  } else {
    initials = namePart.slice(0, 2).toUpperCase();
  }

  const colors = ["#0ea5e9", "#8b5cf6", "#10b981", "#ef4444", "#f59e0b", "#6366f1", "#ec4899"];
  let charSum = 0;
  for (let i = 0; i < initials.length; i++) {
    charSum += initials.charCodeAt(i);
  }
  const color = colors[charSum % colors.length];
  const displayName = parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(" ");

  return { initials, color, displayName };
};

const SixthSection = ({
  allDetail,
  initialData,
  financialData,
  showPopup,
  onRefresh,
  admin,
  selectedProduct,
}) => {
  const [financialDataLocal, setFinancialDataLocal] = useState({ crif: {}, credit: {} });
  const [form, setForm] = useState({
    accountHolder0: "",
    accountNumber0: "",
    accountType0: "",
    obligations: [
      {
        loanType: "",
        existingEmi: "",
        dateOfEmi: "",
        odCcInterest: "",
        pendingEmi: "",
        noOfEmi: "",
        totalObligation: "",
        remark: "",
      },
    ],
    bureauAnalysis: "",
    last12MonthsSales: "",
    relatedPartySales: "",
    debtIncome: "",
    avgNetSales: "",
    monthlyObligations: "",
    projectedMonthlyIncome: "",
  });

  const [bankingData, setBankingData] = useState([]);
  const [bankData, setBankData] = useState({});
  const [allUploadedDocumentsForProcess, setAllUploadedDocumentsForProcess] = useState([]);

  const [accounts, setAccounts] = useState([
    {
      _id: "local_0",
      accountName: "",
      accountNumber: "",
      accountType: "",
    },
  ]);
  const [activeTab, setActiveTab] = useState("local_0");
  const [activeDataToShow, setactiveDataToShow] = useState(accounts[0] || {});
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [_loader, setLoader] = useState(false);
  const [showBankReportPopup, setShowBankReportPopup] = useState(false);
  const [openConfirmAdd, setOpenConfirmAdd] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  // Manually added rows for Monthly Banking Summary
  const [monthlyBankingRows, setMonthlyBankingRows] = useState([]);

  const [sectionCommentText, setSectionCommentText] = useState("");
  const [sectionCommentsList, setSectionCommentsList] = useState([]);
  const [commentBtnLoading, setCommentBtnLoading] = useState(false);
  const [openHistoryPopup, setOpenHistoryPopup] = useState(false);

  // Fetch comments using getFinancialListAPi




  // Save comment using saveFinancialSummaryApi
  const handleSaveComment = () => {
    if (!sectionCommentText.trim() || !allDetail?.userId) return;
    const payload = {
      userId: allDetail.userId,
      body: sectionCommentText.trim(),
      title: "Comment",
      empId: admin?.emailId || "SuperUser",
    };
    setCommentBtnLoading(true);
    saveFinancialSummaryApi(
      payload,
      (res) => {
        setCommentBtnLoading(false);
        setSectionCommentText("");
        
        // Optimistic local storage update for local fallback
        const newLocalComment = {
          id: Date.now(),
          body: payload.body,
          title: payload.title,
          empId: payload.empId,
          date: new Date().toLocaleString("en-IN"),
          dateLong: Date.now(),
        };
        const updatedLocalList = [newLocalComment, ...sectionCommentsList];
        const storageKey = `bank_statement_comments_list_${allDetail.userId}`;
        localStorage.setItem(storageKey, JSON.stringify(updatedLocalList));

        showPopup("Comment saved successfully");
        // fetchComments();
      },
      (err) => {
        setCommentBtnLoading(false);
        setSectionCommentText("");

        // Save locally on error/fallback
        const newLocalComment = {
          id: Date.now(),
          body: payload.body,
          title: payload.title,
          empId: payload.empId,
          date: new Date().toLocaleString("en-IN"),
          dateLong: Date.now(),
        };
        const updatedLocalList = [newLocalComment, ...sectionCommentsList];
        setSectionCommentsList(updatedLocalList);

        const storageKey = `bank_statement_comments_list_${allDetail.userId}`;
        localStorage.setItem(storageKey, JSON.stringify(updatedLocalList));

        showPopup("Comment saved locally (API fallback)");
        console.log("Saved comment locally due to API fallback:", err);
      }
    );
  };

  const monthlyBankingCols = [
    "Total Credit",
    "Total Debit",
    "Avg Balance",
    "No. of Credit Entries",
  ];
  const detailedTransactionCols = [
    "Business Receipt",
    "Vendor Payments",
    "Cash Deposits",
    "Inter-account Transfers",
    "Cheque Inward",
    "Cheque Outward",
    "Loan Credits",
  ];
  const columnKeyMap = {
    "Business Receipt": "businessReceipts",
    "Vendor Payments": "vendorPayments",
    "Cash Deposits": "cashDeposits",
    "Inter-account Transfers": "interAccountTransfers",
    "Cheque Inward": "chequeInward",
    "Cheque Outward": "chequeOutward",
    "Loan Credits": "loanCredits",
  };

  // Fetch all local data
  const fetchBankingData = () => {
    const activeId = allDetail?.applicationId || allDetail?.userId || allDetail?.loanId;
    if (!activeId) return;
    setLoader(true);
    getBankingData(activeId, (callback) => {
      setLoader(false);
      setBankingData(callback?.data ?? []);
    });
    // getCReditRelatedData(activeId, (callback) => {
    //   setFinancialDataLocal((prev) => ({
    //     ...prev,
    //     credit: callback,
    //   }));
    // });
    // getCRifRelatedData(activeId, (callback) => {
    //   setFinancialDataLocal((prev) => ({
    //     ...prev,
    //     crif: callback,
    //   }));
    // });
  };

  const fetchBankReport = () => {
    const activeId = allDetail?.applicationId || allDetail?.userId || allDetail?.loanId;
    if (!activeId) return;
    setLoader(true);
    // getBankReportData("narNarayanFincap_66f1da27", (callback) => {
    //   setLoader(false);
    //   if (callback?.success === true) {
    //     setBankData(callback?.data);
    //   }
    // });
  };

  const fetchUploadedDocs = () => {
    const activeId = allDetail?.applicationId || allDetail?.userId || allDetail?.loanId;
    if (!activeId) return;
    setLoader(true);
    // getAllUploadedDocumentsListForProcessByUserId(activeId, (callback) => {
    //   setLoader(false);
    //   if (callback?.success === true) {
    //     setAllUploadedDocumentsForProcess(callback?.data ?? []);
    //   }
    // });
  };

  const fetchBankStatementAnalysisData = () => {
    const loanId = allDetail?.loanId || allDetail?.applicationId || allDetail?.id || allDetail?.userId;
    if (!loanId) return;

    getBankStatementAnalysis(loanId, (res) => {
      if (!res) return;
      const data = res.data || res.content || res;
      
      const rawAccountsList = Array.isArray(data)
        ? data
        : Array.isArray(data?.accountDetails)
        ? data.accountDetails
        : Array.isArray(res?.data)
        ? res.data
        : [];

      if (rawAccountsList.length > 0) {
        const mappedAccounts = rawAccountsList.map((acc, idx) => ({
          _id: acc.accountId || acc._id || `local_${idx}`,
          accountName: acc.accountHolder || acc.accountName || "",
          accountNumber: acc.accountNumber || "",
          accountType: acc.accountType || "",
          bankingSummary: acc.bankingSummary || [],
          manualBankingSummaryRows: acc.manualBankingSummaryRows || [],
          obligations: acc.obligations || [],
          bureauAnalysis: acc.bureauAnalysis || "",
        }));

        setAccounts(mappedAccounts);
        const firstId = mappedAccounts[0]?._id ?? "local_0";
        setActiveTab(firstId);
        setactiveDataToShow(mappedAccounts[0] ?? {});

        setForm((prev) => {
          let updated = { ...prev };
          mappedAccounts.forEach((acc) => {
            const accId = acc._id;
            updated[`accountHolder${accId}`] = acc.accountName || "";
            updated[`accountNumber${accId}`] = acc.accountNumber || "";
            updated[`accountType${accId}`] = acc.accountType || "";
            updated[`manualBankingSummaryRows_${accId}`] = acc.manualBankingSummaryRows || [];
            updated[`obligations_${accId}`] = acc.obligations || [];
            updated[`bureauAnalysis_${accId}`] = acc.bureauAnalysis || "";
          });
          return updated;
        });

        setMonthlyBankingRows(mappedAccounts[0]?.manualBankingSummaryRows || []);
        setForm((prev) => ({
          ...prev,
          obligations: mappedAccounts[0]?.obligations?.length > 0 ? mappedAccounts[0].obligations : [
            { loanType: "", existingEmi: "", dateOfEmi: "", odCcInterest: "", pendingEmi: "", noOfEmi: "", totalObligation: "", remark: "" }
          ],
          bureauAnalysis: mappedAccounts[0]?.bureauAnalysis || "",
        }));
      } else if (data && (data.accountHolder || data.accountHolder0)) {
        setForm((prev) => ({
          ...prev,
          accountHolder0: data.accountHolder || data.accountHolder0 || "",
          accountNumber0: data.accountNumber || data.accountNumber0 || "",
          accountType0: data.accountType || data.accountType0 || "",
        }));
      }
    });
  };

  useEffect(() => {
    const activeId = allDetail?.applicationId || allDetail?.userId || allDetail?.loanId;
    if (activeId) {
      fetchBankingData();
      fetchBankStatementAnalysisData();
      // fetchBankReport();
      // fetchUploadedDocs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allDetail]);

  // Sync state with parent-supplied initialData
  useEffect(() => {
    if (initialData) {
      setForm((prev) => ({
        ...prev,
        accountHolder0: initialData.accountHolder0 ?? "",
        accountNumber0: initialData.accountNumber0 ?? "",
        accountType0: initialData.accountType0 ?? "",
        obligations: initialData.obligations ?? [],
        bureauAnalysis: initialData.bureauAnalysis ?? "",
        last12MonthsSales: initialData.last12MonthsSales ?? "",
        relatedPartySales: initialData.relatedPartySales ?? "",
        debtIncome: initialData.debtIncome ?? "",
        avgNetSales: initialData.avgNetSales ?? "",
        monthlyObligations: initialData.monthlyObligations ?? "",
        projectedMonthlyIncome: initialData.projectedMonthlyIncome ?? "",
      }));
    }
  }, [initialData]);

  // Sync tab data when bankingData fetches
  useEffect(() => {
    if (bankingData?.length > 0) {
      setAccounts(bankingData);
      setActiveTab(bankingData[0]?._id ?? 0);
      setactiveDataToShow(bankingData[0] ?? {});

      setForm((prev) => {
        let updated = { ...prev };
        bankingData.forEach((acc) => {
          updated[`accountHolder${acc._id}`] = acc.accountName ?? "";
          updated[`accountNumber${acc._id}`] = acc.accountNumber ?? "";
          updated[`accountType${acc._id}`] = acc.accountType ?? "";
        });
        return updated;
      });
    }
  }, [bankingData]);

  const handleChange = (e, field) => {
    const val = e.target.value;
    setForm((prev) => ({
      ...prev,
      [field]: val,
    }));
  };

  const handleObligationChange = (index, field, value) => {
    const updatedObligations = [...(form.obligations || [])];
    updatedObligations[index] = {
      ...updatedObligations[index],
      [field]: value,
    };
    setForm((prev) => ({
      ...prev,
      obligations: updatedObligations,
    }));
  };

  const addObligationRow = () => {
    const newRow = {
      loanType: "",
      existingEmi: "",
      dateOfEmi: "",
      odCcInterest: "",
      pendingEmi: "",
      noOfEmi: "",
      totalObligation: "",
      remark: "",
    };
    setForm((prev) => ({
      ...prev,
      obligations: [...(prev.obligations || []), newRow],
    }));
  };

  const removeObligationRow = (indexToRemove) => {
    if (form.obligations.length === 1) {
      alert("At least one row must remain");
      return;
    }
    const updated = form.obligations.filter((_, index) => index !== indexToRemove);
    setForm((prev) => ({
      ...prev,
      obligations: updated,
    }));
  };

  // ── Monthly Banking Summary manual row handlers ──
  const addMonthlyBankingRow = () => {
    setMonthlyBankingRows((prev) => [
      ...prev,
      { month: "", totalCredits: "", totalDebits: "", avgBalance: "", creditEntries: "" },
    ]);
  };

  const removeMonthlyBankingRow = (idx) => {
    setMonthlyBankingRows((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleMonthlyBankingChange = (idx, field, value) => {
    setMonthlyBankingRows((prev) =>
      prev.map((row, i) => (i === idx ? { ...row, [field]: value } : row))
    );
  };

  const handleAccTab = (id, value) => {
    // 1. Save current activeTab's state into form dictionary
    setForm((prev) => ({
      ...prev,
      [`manualBankingSummaryRows_${activeTab}`]: monthlyBankingRows,
      [`obligations_${activeTab}`]: prev.obligations,
      [`bureauAnalysis_${activeTab}`]: prev.bureauAnalysis,
      [`accountHolder${id}`]: prev[`accountHolder${id}`] ?? value?.accountName ?? "",
      [`accountNumber${id}`]: prev[`accountNumber${id}`] ?? value?.accountNumber ?? "",
      [`accountType${id}`]: prev[`accountType${id}`] ?? value?.accountType ?? "",
    }));

    // 2. Switch active tab
    setActiveTab(id);
    setactiveDataToShow(value);

    // 3. Load target tab's per-account state into view
    const targetMonthlyRows = form[`manualBankingSummaryRows_${id}`] || value?.manualBankingSummaryRows || [];
    const targetObligations = form[`obligations_${id}`] || value?.obligations || [
      { loanType: "", existingEmi: "", dateOfEmi: "", odCcInterest: "", pendingEmi: "", noOfEmi: "", totalObligation: "", remark: "" }
    ];
    const targetBureauAnalysis = form[`bureauAnalysis_${id}`] ?? value?.bureauAnalysis ?? "";

    setMonthlyBankingRows(targetMonthlyRows);
    setForm((prev) => ({
      ...prev,
      obligations: targetObligations,
      bureauAnalysis: targetBureauAnalysis,
    }));
  };

  const formatLakh = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return (Number(value) / 100000).toFixed(2);
  };

  const handleAddAccount = () => {
    setOpenConfirmAdd(true);
  };

  const handleConfirmAddAccount = () => {
    // Save current active tab state
    setForm((prev) => ({
      ...prev,
      [`manualBankingSummaryRows_${activeTab}`]: monthlyBankingRows,
      [`obligations_${activeTab}`]: prev.obligations,
      [`bureauAnalysis_${activeTab}`]: prev.bureauAnalysis,
    }));

    const newId = `local_${Date.now()}`;
    const defaultObligations = [
      { loanType: "", existingEmi: "", dateOfEmi: "", odCcInterest: "", pendingEmi: "", noOfEmi: "", totalObligation: "", remark: "" }
    ];

    const newAccount = {
      _id: newId,
      accountName: "",
      accountNumber: "",
      accountType: "",
      manualBankingSummaryRows: [],
      obligations: defaultObligations,
      bureauAnalysis: "",
    };

    const updated = [...accounts, newAccount];
    setAccounts(updated);
    setActiveTab(newId);
    setactiveDataToShow(newAccount);

    setMonthlyBankingRows([]);
    setForm((prev) => ({
      ...prev,
      [`accountHolder${newId}`]: "",
      [`accountNumber${newId}`]: "",
      [`accountType${newId}`]: "",
      [`manualBankingSummaryRows_${newId}`]: [],
      [`obligations_${newId}`]: defaultObligations,
      [`bureauAnalysis_${newId}`]: "",
      obligations: defaultObligations,
      bureauAnalysis: "",
    }));
    setOpenConfirmAdd(false);
  };

  const handleCancelAddAccount = () => {
    setOpenConfirmAdd(false);
  };

  const handleDeleteAccount = (idToRemove) => {
    const updated = accounts.filter((acc) => acc._id !== idToRemove);
    setAccounts(updated);
    const nextActiveId = updated[0]?._id ?? "local_0";
    setActiveTab(nextActiveId);
    setactiveDataToShow(updated[0] ?? {});
  };

  const handleSave = () => {
    const stripId = ({ _id, ...rest }) => rest;
    setBtnLoading(true);

    const activeLoanId = allDetail?.loanId || allDetail?.applicationId || allDetail?.id || allDetail?.userId;

    // Current tab values
    const currentTabMonthlyRows = monthlyBankingRows;
    const currentTabObligations = form.obligations;
    const currentTabBureauAnalysis = form.bureauAnalysis;

    // Build array of ALL bank accounts info to save simultaneously
    const accountsData = accounts.map((acc, index) => {
      const accId = acc._id || index;
      const isActive = accId === activeTab;

      const accountHolder = form[`accountHolder${accId}`] || acc.accountName || form.accountHolder0 || "";
      const accountNumber = form[`accountNumber${accId}`] || acc.accountNumber || form.accountNumber0 || "";
      const accountType = form[`accountType${accId}`] || acc.accountType || form.accountType0 || "";
      
      const accMonthlyRows = isActive ? currentTabMonthlyRows : (form[`manualBankingSummaryRows_${accId}`] || acc.manualBankingSummaryRows || []);
      const accObligations = (isActive ? currentTabObligations : (form[`obligations_${accId}`] || acc.obligations || [])).map(stripId);
      const accBureauAnalysis = isActive ? currentTabBureauAnalysis : (form[`bureauAnalysis_${accId}`] ?? acc.bureauAnalysis ?? "");

      const summaryRows = (acc.bankingSummary || []).map((col, id) => ({
        month: col?.month,
        totalCredits: form[`mb_${accId}_${id}_totalCredits`] ?? col?.totalCredits ?? "",
        totalDebits: form[`mb_${accId}_${id}_totalDebits`] ?? col?.totalDebits ?? "",
        avgBalance: form[`mb_${accId}_${id}_avgBalance`] ?? col?.avgBalance ?? "",
        creditEntries: form[`mb_${accId}_${id}_creditEntries`] ?? col?.creditEntries ?? "",
      }));

      return {
        accountId: acc._id,
        accountHolder,
        accountNumber,
        accountType,
        bankingSummary: summaryRows,
        manualBankingSummaryRows: accMonthlyRows,
        obligations: accObligations,
        bureauAnalysis: accBureauAnalysis,
      };
    });

    const analysisPayload = {
      loanId: activeLoanId,
      userId: allDetail?.userId,
      applicationId: allDetail?.applicationId || allDetail?.loanId,
      accountDetails: accountsData, // Array containing all account details, summaries, obligations, and bureau analysis
    };

    saveBankStatementAnalysis(
      analysisPayload,
      (res) => {
        setBtnLoading(false);
        showPopup("Bank Statement Analysis saved successfully");
        if (onRefresh) onRefresh();
        fetchBankingData();
        fetchBankStatementAnalysisData();
      },
      (err) => {
        saveBankStatementSection(
          allDetail?.userId,
          analysisPayload,
          (res) => {
            setBtnLoading(false);
            if (res?.success === true) {
              showPopup("Bank Statement Section saved successfully");
              if (onRefresh) onRefresh();
              fetchBankingData();
              fetchBankStatementAnalysisData();
            } else {
              showPopup("Error saving bank statement section");
            }
          },
          (e) => {
            setBtnLoading(false);
            showPopup("Error saving bank statement section");
          }
        );
      }
    );
  };

  const financeData = financialDataLocal?.credit?.data || financialData?.credit?.data || {};
  const showDetailedAnalysis = selectedProduct === "Rs 300000 to 500000" || form?.product === "Rs 300000 to 500000" || initialData?.product === "Rs 300000 to 500000";

  return (
    <div style={{ marginTop: "12px", background: "#F9FAFB" }}>
     
      <CustomHeading
        title="Bank Statement Analysis"
        subtitle="Last 6 months banking behavior (All amounts in Lakhs )"
        buttonText="Positive"
        icon={CheckCircle}
        buttonColor="#4CAF50"
        borderColor="#F5A676"
        background="#FFF5EB"
      />
      

      {/* ── Account Tabs & Save Action ── */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginTop: "20px",
          marginBottom: "16px",
          flexWrap: "wrap",
        }}
      >
        {accounts.map((tab, id) => (
          <button
            key={tab._id}
            onClick={() => handleAccTab(tab._id, tab)}
            style={{
              padding: "8px 20px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: activeTab === tab._id ? "600" : "400",
              background: activeTab === tab._id ? "#035865" : "transparent",
              color: activeTab === tab._id ? "#fff" : "#686C70",
              transition: "all 0.15s ease",
            }}
          >
            Account {id + 1}
          </button>
        ))}

        <button
          onClick={handleAddAccount}
          style={{
            padding: "6px 14px",
            borderRadius: "6px",
            border: "1.5px dashed #035865",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "500",
            background: "transparent",
            color: "#035865",
            transition: "all 0.15s ease",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#f0fafa")}
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          <Plus size={14} style={{width:'auto'}}/> Add Account
        </button>

        <div style={{ flex: 1 }} />

        <Button
          title="Save Data"
          onClick={handleSave}
          btnLoading={btnLoading}
        />
      </div>

      {/* ── Account Details ── */}
      <div style={card}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <h5 style={{ ...sectionTitle, margin: 0 }}>Account Details</h5>
          {activeTab?.toString().startsWith("local_") &&
            activeTab !== accounts[0]?._id && (
              <button
                onClick={() => handleDeleteAccount(activeTab)}
                style={{
                  background: "#ef4444",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "6px 12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                <Trash2 size={14} />
              </button>
            )}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 14,
          }}
        >
          <div>
            <CustomInput
              label={"Account Holder"}
              type="text"
              placeholder="-"
              value={form[`accountHolder${activeTab}`] || ""}
              onChange={(e) => handleChange(e, `accountHolder${activeTab}`)}
            />
          </div>
          <div>
            <CustomInput
              label={"Account Number"}
              type="text"
              placeholder="-"
              value={form[`accountNumber${activeTab}`] || ""}
              onChange={(e) => handleChange(e, `accountNumber${activeTab}`)}
            />
          </div>
          <div>
            <CustomSelect
              label={"Account Type"}
              value={form[`accountType${activeTab}`] || ""}
              onChange={(e) => handleChange(e, `accountType${activeTab}`)}
              options={[
                { label: "-", value: "" },
                { label: "Savings", value: "Saving" },
                { label: "Current", value: "Current" },
                { label: "OD / CC", value: "OD/CC" },
              ]}
            />
          </div>
        </div>
      </div>

      {/* ── Monthly Banking Summary ── */}
      <div style={{ ...card, marginTop: 12 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <h5 style={{ ...sectionTitle, margin: 0 }}>Monthly Banking Summary (₹ In Lakh)</h5>
          <button onClick={addMonthlyBankingRow} style={addBtn}>
            <Plus size={14} style={{ width: "auto" }} /> Add Row
          </button>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={tableBase}>
            <thead>
              <tr>
                <th style={{ ...th, width: "70px" }}>Month</th>
                {monthlyBankingCols.map((h) => (
                  <th key={h} style={th}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* ── API-sourced rows (read + editable via existing form keys) ── */}
              {(activeDataToShow?.bankingSummary || financeData?.bankingSummary || []).map((col, id) => {
                const fieldKey1 = `mb_${activeTab}_${id}_totalCredits`;
                const fieldKey2 = `mb_${activeTab}_${id}_totalDebits`;
                const fieldKey3 = `mb_${activeTab}_${id}_avgBalance`;
                const fieldKey4 = `mb_${activeTab}_${id}_creditEntries`;
                const isAccount1 = activeTab === (accounts[0]?._id ?? "local_0");
                return (
                  <tr key={id} style={{ borderBottom: "1px solid #f3f4f6" }}>
                    <td style={{ ...td, color: "#9ca3af", fontWeight: 500 }}>
                      {formatMonth(col?.month)}
                    </td>
                    <td style={td}>
                      <CustomInput
                        type="text"
                        value={
                          form[fieldKey1] ??
                          (activeDataToShow?.bankingSummary
                            ? col?.totalCredits
                            : isAccount1
                            ? formatLakh(col?.totalCredits)
                            : "")
                        }
                        onChange={(e) => handleChange(e, fieldKey1)}
                      />
                    </td>

                    <td style={td}>
                      <CustomInput
                        type="text"
                        value={
                          form[fieldKey2] ??
                          (activeDataToShow?.bankingSummary
                            ? col?.totalDebits
                            : isAccount1
                            ? formatLakh(col?.totalDebits)
                            : "")
                        }
                        onChange={(e) => handleChange(e, fieldKey2)}
                      />
                    </td>

                    <td style={td}>
                      <CustomInput
                        type="text"
                        value={
                          form[fieldKey3] ??
                          (activeDataToShow?.bankingSummary
                            ? col?.avgBalance
                            : isAccount1
                            ? formatLakh(col?.avgBalance)
                            : "")
                        }
                        onChange={(e) => handleChange(e, fieldKey3)}
                      />
                    </td>

                    <td style={td}>
                      <CustomInput
                        type="text"
                        value={
                          form[fieldKey4] ??
                          (activeDataToShow?.bankingSummary
                            ? col?.creditEntries
                            : isAccount1
                            ? formatLakh(col?.creditEntries)
                            : "")
                        }
                        onChange={(e) => handleChange(e, fieldKey4)}
                      />
                    </td>
                  </tr>
                );
              })}

              {/* ── Manually added rows ── */}
              {monthlyBankingRows.map((row, idx) => (
                <tr key={`manual_mb_${idx}`} style={{ borderBottom: "1px solid #f3f4f6", background: "#fafffe" }}>
                  <td style={td}>
                    <input
                      type="month"
                      value={row.month}
                      onChange={(e) => handleMonthlyBankingChange(idx, "month", e.target.value)}
                      style={{
                        border: "1px solid #d1d5db",
                        borderRadius: 6,
                        padding: "5px 8px",
                        fontSize: 12,
                        color: "#374151",
                        outline: "none",
                        width: "100%",
                      }}
                    />
                  </td>
                  {[
                    { field: "totalCredits", placeholder: "Total Credit" },
                    { field: "totalDebits",  placeholder: "Total Debit" },
                    { field: "avgBalance",   placeholder: "Avg Balance" },
                    { field: "creditEntries",placeholder: "No. of Entries" },
                  ].map(({ field, placeholder }) => (
                    <td key={field} style={td}>
                      <input
                        type="number"
                        placeholder={placeholder}
                        value={row[field]}
                        onChange={(e) => handleMonthlyBankingChange(idx, field, e.target.value)}
                        style={{
                          border: "1px solid #d1d5db",
                          borderRadius: 6,
                          padding: "5px 8px",
                          fontSize: 12,
                          color: "#374151",
                          outline: "none",
                          width: "100%",
                          minWidth: "90px",
                        }}
                      />
                    </td>
                  ))}
                  <td style={{ ...td, textAlign: "center" }}>
                    <button
                      onClick={() => removeMonthlyBankingRow(idx)}
                      style={{
                        background: "#ef4444",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding: "5px 8px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Remove row"
                    >
                      <Trash2 size={13} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Detailed Transaction Analysis ── */}
      {showDetailedAnalysis && (
        <div style={{ ...card, marginTop: 12 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 14,
            }}
          >
            <h5 style={sectionTitle}>
              Detailed Transaction Analysis (₹ In Lakh)
            </h5>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={tableBase}>
              <thead>
                <tr>
                  <th style={{ ...th, width: "120px" }}>Month</th>
                  {detailedTransactionCols.map((h) => (
                    <th key={h} style={th}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(activeDataToShow?.transactionAnalysis || financeData?.transactionAnalysis || []).map((row, i) => {
                  const isAccount1 = activeTab === (accounts[0]?._id ?? "local_0");
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #f3f4f6" }}>
                      <td style={{ ...td, color: "#9ca3af", fontWeight: 500 }}>
                        {formatMonth(row?.month)}
                      </td>

                      {detailedTransactionCols.map((col) => {
                        const apiKey = columnKeyMap[col];
                        const fieldKey = `dt_${activeTab}_${apiKey}_${i}`;

                        return (
                          <td key={col} style={td}>
                            <CustomInput
                              type="text"
                              value={
                                form[fieldKey] ??
                                (activeDataToShow?.transactionAnalysis
                                  ? row?.[apiKey]
                                  : isAccount1
                                  ? formatLakh(row?.[apiKey])
                                  : "")
                              }
                              onChange={(e) => handleChange(e, fieldKey)}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── Obligation Tracker ── */}
      <div style={{ ...card, marginTop: 12 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <h5 style={{ ...sectionTitle, margin: 0 }}>Obligation Tracker</h5>
          <button onClick={addObligationRow} style={addBtn}>
            <Plus size={14} /> Add Row
          </button>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={tableBase}>
            <thead>
              <tr>
                {[
                  "Loan Type",
                  "Existing EMI",
                  "Date of EMI",
                  "OD / CC Interest",
                  "Pending EMI",
                  "No. of EMI",
                  "Total Obligation",
                  "Remark",
                  "Action",
                ].map((h) => (
                  <th
                    key={h}
                    style={{ ...th, width: h === "Action" ? "60px" : "auto" }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(form.obligations || []).map((row, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #f3f4f6" }}>
                  {[
                    "loanType",
                    "existingEmi",
                    "dateOfEmi",
                    "odCcInterest",
                    "pendingEmi",
                    "noOfEmi",
                    "totalObligation",
                    "remark",
                  ].map((field) => (
                    <td key={field} style={td}>
                      <CustomInput
                        type={field === "dateOfEmi" ? "date" : "text"}
                        placeholder=""
                        value={row[field] || ""}
                        onChange={(e) =>
                          handleObligationChange(index, field, e.target.value)
                        }
                      />
                    </td>
                  ))}
                  <td style={{ ...td, textAlign: "center" }}>
                    <button
                      onClick={() => removeObligationRow(index)}
                      style={{
                        background: "#ef4444",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding: "5px 8px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Delete row"
                    >
                      <Trash2 size={13} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: 18, marginBottom: "16px" }}>
          <label
            style={{
              fontSize: "14px",
              fontWeight: 500,
              display: "block",
              marginBottom: "6px",
              color: "#374151",
            }}
          >
            Bureau Analysis
          </label>
          <textarea
            placeholder="Bureau Analysis description..."
            value={form.bureauAnalysis}
            onChange={(e) => handleChange(e, "bureauAnalysis")}
            rows={4}
            style={{
              width: "100%",
              border: "1.5px solid #cbd5e1",
              borderRadius: "10px",
              padding: "10px 12px",
              fontFamily: "inherit",
              fontSize: "13px",
              color: "#0f172a",
              outline: "none",
              background: "#fff",
              boxSizing: "border-box",
              resize: "vertical",
              minHeight: "90px",
              lineHeight: 1.6,
              transition: "all 0.15s ease",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#035865";
              e.target.style.boxShadow = "0 0 0 3px rgba(3,88,101,.12)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#cbd5e1";
              e.target.style.boxShadow = "none";
            }}
          />
        </div>
      </div>

      {/* ── FOIR Calculator (Commented out) ── */}
      {/* 
      <div style={{ ...card, marginTop: 12 }}>
        <h5 style={{ ...sectionTitle, marginBottom: 16 }}>FOIR Calculator</h5>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 14,
          }}
        >
          {[
            { field: "last12MonthsSales", label: "Last 12 months sales" },
            { field: "relatedPartySales", label: "Related Party Sales" },
            { field: "debtIncome", label: "Debt / Income" },
          ].map(({ field, label: lbl }) => (
            <div key={field}>
              <CustomInput
                label={lbl}
                type="text"
                placeholder=""
                value={form[field] || ""}
                onChange={(e) => handleChange(e, field)}
              />
            </div>
          ))}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "14px",
            marginTop: "14px",
          }}
        >
          <div>
            <CustomInput
              label={"Monthly Obligations"}
              type="text"
              placeholder=""
              value={form.monthlyObligations || ""}
              onChange={(e) => handleChange(e, "monthlyObligations")}
            />
          </div>
          <div>
            <CustomInput
              label={"Projected monthly income"}
              type="text"
              placeholder=""
              value={form.projectedMonthlyIncome || ""}
              onChange={(e) => handleChange(e, "projectedMonthlyIncome")}
            />
          </div>
          <div>
            <CustomInput
              label={"Avg Net sales excluding rel. party with 10% increase."}
              type="text"
              placeholder=""
              value={form.avgNetSales || ""}
              onChange={(e) => handleChange(e, "avgNetSales")}
            />
          </div>
        </div>
      </div>
      */}

      {/* Add Bank Account Popup */}
      <AddBankAccountPopup
        open={showUploadPopup}
        onClose={() => {
          setShowUploadPopup(false);
          fetchBankingData();
        }}
        setLoader={setLoader}
        allDetail={allDetail}
        callAllApis={fetchBankingData}
        allUploadedDocumentsForProcess={allUploadedDocumentsForProcess}
      />

      {showBankReportPopup && (
        <div
          className="modal-overlay"
          onClick={() => setShowBankReportPopup(false)}
        >
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <h2 style={{ fontSize: "16px" }}>Bank Statement Dashboard</h2>
                <button
                  className="close-btn"
                  onClick={() => setShowBankReportPopup(false)}
                >
                  &times;
                </button>
              </div>
            </div>
            <div className="modal-body">
              <BankStatementDashboard data={bankData} allDetail={allDetail} />
            </div>
          </div>
        </div>
      )}

      {/* MUI confirmation dialog for adding a new bank account */}
      <Dialog
        open={openConfirmAdd}
        onClose={handleCancelAddAccount}
        PaperProps={{
          style: {
            borderRadius: "16px",
            padding: "8px",
            boxShadow: "0 24px 48px rgba(15,23,42,0.18)",
          },
        }}
      >
        <DialogTitle
          style={{ fontWeight: 700, color: "#0f172a", fontSize: "18px" }}
        >
          Add New Bank Account
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            style={{ color: "#475569", fontSize: "14px", lineHeight: 1.6 }}
          >
            Are you sure you want to add a new bank account? This will create a
            new tab with blank fields for you to fill out.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px", gap: "12px" }}>
          <MuiButton
            onClick={handleCancelAddAccount}
            variant="outlined"
            style={{
              borderColor: "#cbd5e1",
              color: "#475569",
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "8px",
              padding: "6px 16px",
              height: "36px",
              fontSize: "14px",
            }}
          >
            Cancel
          </MuiButton>
          <MuiButton
            onClick={handleConfirmAddAccount}
            variant="contained"
            style={{
              backgroundColor: "#035865",
              color: "#fff",
              textTransform: "none",
              fontWeight: 700,
              borderRadius: "8px",
              padding: "6px 16px",
              height: "36px",
              fontSize: "12px",
            }}
          >
            Yes, Add Account
          </MuiButton>
        </DialogActions>
      </Dialog>


    </div>
  );
};

// ── Shared styles ──────────────────────────────────────────
const card = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 12,
  padding: "16px 18px",
  boxShadow: "0 1px 3px rgba(0,0,0,.05)",
};
const sectionTitle = {
  fontSize: 13,
  fontWeight: 700,
  margin: "0 0 2px",
  color: "#374151",
  letterSpacing: ".01em",
};
const tableBase = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: 12,
};
const th = {
  padding: "9px 11px",
  textAlign: "left",
  fontWeight: 600,
  color: "#6b7280",
  fontSize: 11,
  background: "#f9fafb",
  borderBottom: "1px solid #e5e7eb",
  whiteSpace: "nowrap",
  letterSpacing: ".02em",
  textTransform: "uppercase",
};
const td = {
  padding: "6px 8px",
  color: "#374151",
  fontSize: 12,
  verticalAlign: "middle",
};
const addBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  background: "#035865",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  padding: "7px 14px",
  fontSize: 12,
  fontWeight: 600,
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "opacity .12s",
};

export default SixthSection;
